// src/api/drinkApi.js
import axios from "axios";

import { ENDPOINTS } from "../jsx/services/ENDPOINT";

const BASE_URL =`${ENDPOINTS.BASE_2}/drinks` ;

export const getDrinks = () => axios.get(BASE_URL);

export const createDrink = (data) => axios.post(BASE_URL, data);

export const updateDrink = (id, data) =>
  axios.put(`${BASE_URL}/${id}`, data);

export const deleteDrink = (id) =>
  axios.delete(`${BASE_URL}/${id}`);